import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import HeroImage from "../assets/HeroImage.png";
import { Link } from "react-scroll";

function Home() {
  return (
    <div
      name="home"
      className="w-full bg-gradient-to-b from-black via-black to-gray-800 pt-20"
    >
      <div className="min-h-[calc(100vh-5rem)] flex items-center">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center px-6 gap-x-16">
          {/* Left Content */}
          <div className="flex flex-col justify-center md:ml-8">
            <h2 className="text-4xl sm:text-7xl font-bold text-white leading-tight">
              I'm a MERN
              <br />
              Developer
            </h2>

            <p className="text-gray-400 py-6 max-w-md">
              I’m a full-stack MERN developer with strong problem-solving skills
              and hands-on experience building real-world applications. I focus
              on writing clean, scalable code, designing REST APIs, and creating
              responsive user interfaces, while continuously strengthening my
              DSA and core CS fundamentals.
            </p>

            <div>
              <Link
                to="portfolio"
                smooth
                duration={500}
                className="text-white group w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
              >
                Portfolio
                <span className="group-hover:rotate-90 duration-300">
                  <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                </span>
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="mt-8 md:mt-0">
            <img
              src={HeroImage}
              alt="profile"
              className="rounded-xl w-72 md:w-80 shadow-xl"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
